import React from "react";
import { Radio, Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import CustomTypography from "../../../commonComponents/CustomTypography";
import { formatUSPhoneNumber } from "../../../../utils/formatters";

const UserListItem = ({ user, selected, onSelect }) => {
  // Get initials from firstName and lastName
  const getInitials = () => {
    const firstInitial = user.firstName?.charAt(0)?.toUpperCase() || "";
    const lastInitial = user.lastName?.charAt(0)?.toUpperCase() || "";
    return firstInitial + lastInitial;
  };

  return (
    <div
      className={`flex items-center gap-3 p-3 ${
        selected
          ? "bg-[#E6F4FF] border border-solid border-[#91CAFF]"
          : "bg-white hover:bg-[#F5F5F5]"
      } cursor-pointer rounded w-full`}
      onClick={() => onSelect(user.id)}
    >
      {/* Radio Button */}
      <Radio checked={selected} />

      {/* User Avatar */}
      <Avatar size={40} src={user.profilePic || user.avatar}>
        {!user.profilePic && !user.avatar && getInitials()}
      </Avatar>

      {/* User Info */}
      <div className="flex-1">
        <div className="flex items-center gap-1 mb-1">
          {/* User Name - Text Base/Strong */}
          <CustomTypography variant="text" strong className="!text-black">
            {user.fullName || user.name}
          </CustomTypography>
          {/* Role - Text Base/Normal in parentheses */}
          {(user.companyRole?.name || user.role) && (
            <CustomTypography variant="text" className="text-[#000000A6]">
              ({user.companyRole?.name || user.role})
            </CustomTypography>
          )}
        </div>
        {/* Phone Number - Text Base/Normal */}
        {user.phone && (
          <CustomTypography variant="text" className="text-[#000000A6]">
            {formatUSPhoneNumber(user.phone)}
          </CustomTypography>
        )}
      </div>
    </div>
  );
};

export default UserListItem;
